<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><em class="italic">For my father Sefton Sandford (1925–2012), a great navy man</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?08f1f54f